import React from "react";

const TerminalIcon = ({ color="#000000", size=16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.5703 1.42786H1.42848C0.639524 1.42786 0 2.06675 0 2.8557V17.143C0 17.9314 0.639524 18.5715 1.42848 18.5715H18.5703C19.3579 18.5715 20 17.9307 20 17.143V2.8557C20 2.06675 19.3579 1.42786 18.5703 1.42786ZM4.6432 2.50048C5.03704 2.50048 5.35744 2.81835 5.35744 3.21472C5.35744 3.6092 5.03704 3.92706 4.6432 3.92706C4.24682 3.92706 3.92706 3.6092 3.92706 3.21472C3.92706 2.81835 4.24682 2.50048 4.6432 2.50048ZM2.49921 2.50048C2.89369 2.50048 3.21282 2.81835 3.21282 3.21472C3.21282 3.6092 2.89369 3.92706 2.49921 3.92706C2.1041 3.92706 1.78433 3.6092 1.78433 3.21472C1.78433 2.81835 2.1041 2.50048 2.49921 2.50048ZM18.5703 17.1437H1.42848V5.01489H18.5703V17.1437Z"
        fill={color}
      />
      <path
        d="M8.00673 7.95043L3.41925 5.85266V6.86387L6.96702 8.38036V8.39999L3.41925 9.91585V10.9264L8.00673 8.82866V7.95043Z"
        fill={color}
      />
      <path
        d="M12.6651 7.90735H10.1665V8.87107H12.6651V7.90735Z"
        fill={color}
      />
    </svg>
  );
};

export default TerminalIcon